// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"1775aaf2","453":"8147c324","455":"52dbea96","546":"1d10e770","977":"0196cbe6"}[chunkId] + ".chunk.js";
};